import {defineStore} from 'pinia'
import store from "store";
// import useAuthnStore from "@/store/authn";
// import Vue from "vue";


const chargeProjectStore = defineStore('charge-project-store', {
    state: () => ({
        chargeProject: store.get('chargeProjectStore') || {
            projectList: undefined,
            strProjectList: undefined,
            strSubProjectList: undefined,
            isChangePro: false,
        },

        ...store.get('chargeProjectStore')
    }),
    getters: {
        getProjectList(state) {
            return state.chargeProject.projectList;
        },
        getChangePro(state) {
            return state.chargeProject.isChangePro;
        },
        getStrProjectList(state) {
            return state.chargeProject.strProjectList;
        },
        getStrSubProjectList(state) {
            return state.chargeProject.strSubProjectList;
        },
    },
    actions: {
        setProjectList(projectList){
            this.chargeProject.projectList = projectList;
            store.set("chargeProjectStore",this.chargeProject)
        },
        setStrProjectList(strProjectList){
            this.chargeProject.strProjectList = strProjectList;
            store.set("chargeProjectStore",this.chargeProject)
        },
        setStrSubProjectList(strSubProjectList){
            this.chargeProject.strSubProjectList = strSubProjectList;
            store.set("chargeProjectStore",this.chargeProject)
        },
        setIsChangePro(boolean) {
            this.chargeProject.isChangePro = boolean;
            store.set("chargeProjectStore",this.chargeProject)
        }
    },
})

export default chargeProjectStore;
